//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.PmiAttributeBuilder.js";
let d=[[],[],[]];
SPLM.Annotations.BaseSurfaceFinishBuilder = class extends SPLM.Annotations.PmiAttributeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BaseSurfaceFinishBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BaseSurfaceFinishBuilder.ToleranceOption = Object.freeze({
    "None" : "None", "EqualBilateral" : "EqualBilateral", "Bilateral" : "Bilateral", "UnilateralPlus" : "UnilateralPlus", "UnilateralMinus" : "UnilateralMinus", "PlusLimitTwoLines" : "PlusLimitTwoLines", "MinusLimitTwoLines" : "MinusLimitTwoLines", "PlusLimitOneLine" : "PlusLimitOneLine", "MinusLimitOneLine" : "MinusLimitOneLine"});

SPLM.Annotations.BaseSurfaceFinishBuilder.ParanthesesType = Object.freeze({
    "None" : "None", "Left" : "Left", "Right" : "Right", "Both" : "Both"});

SPLM.Annotations.BaseSurfaceFinishBuilder.ParenthesesType = Object.freeze({
    "None" : "None", "Left" : "Left", "Right" : "Right", "Both" : "Both"});

export default SPLM;